import {
	Card,
	makeStyles, Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
	Typography,
	SvgIcon, TextField,
	InputAdornment,
	Tooltip,
	TableContainer,
	Chip
} from '@material-ui/core';
import React from 'react';
import { Search as SearchIcon } from 'react-feather';
import Fuse from 'fuse.js';
import dayjs from 'dayjs';
import { useActions, useValues } from 'kea';

import vehiclelogic from 'src/store/vehicle';

import ActionButton from './components/ActionButtons';
import EnableButton from './components/EnableButton';


const withTooltip = (text, width) => (
	<Tooltip title={text}>
		<div style={{
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			width: `${width}px`
		}}>
			{text}
		</div>
	</Tooltip >
)

const useStyles = makeStyles({
	root: {
		width: "100%"
	},
	container: {
		maxHeight: '440'
	},
	box: {
		width: '100%'
	},
	alignLeft: {
		float: 'left',
		width: '50%'
	},
	alignRight: {
		float: 'right',
		width: '50%'
	}
});

const options = {
	includeScore: false,
	includeMatches: true,
	keys: [
		'vehicle.color',
		'vehicle.company',
		'vehicle.name',
		'vehicle.model',
		'vehicle.registration_number',
		'vehicle.registration_state',
		'vehicle.type',
		'vehicle.year',
	]
}

const Results = ({ selectedAlert, columns }) => {
	const classes = useStyles();
	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(10);

	const { vehicles } = useValues(vehiclelogic);


	let rows = { ...selectedAlert };
	rows.vehicles = rows.vehicles.map((vehicle) => {
		vehicle.vehicle.tracker = vehicles.find(ma => ma._id === vehicle.vehicle._id).tracker;
	})
	const [searchField, setSearchField] = React.useState('');

	const handleChangePage = (_even, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (
		event
	) => {
		setRowsPerPage(+event.target.value);
		setPage(0);
	};

	if (searchField) {
		const fuse = new Fuse(rows.vehicles, options);
		let tmp = fuse.search(searchField);
		rows.vehicles = tmp.map(item => {
			return item.item;
		})
	} else if (!searchField.localeCompare('')) {
		rows = { ...selectedAlert };
	}
	return (
		<Card
			className={classes.root}
		>
			<div style={{ height: '100%', width: '100%', background: 'white' }}>
				<TableContainer className={classes.container}>
					<Table stickyHeader aria-label="sticky table" size='small'>
						<TableHead>
							<TableRow>
								<TableCell colSpan={columns.length} align={'left'}>
									<div className={classes.box}>
										<div className={classes.alignLeft}>
											<Typography variant="h4">
												{selectedAlert.name}
											</Typography>
										</div>
										<div className={classes.alignRight}>
											<TextField
												fullWidth
												size={'small'}
												InputProps={{
													startAdornment: (
														<InputAdornment position="start">
															<SvgIcon
																fontSize="small"
																color="action"
															>
																<SearchIcon />
															</SvgIcon>
														</InputAdornment>
													)
												}}
												onChange={e => setSearchField(e.target.value)}
												placeholder="Search Included Vehicle"
												variant="outlined"
											/>
										</div>
									</div>
								</TableCell>
							</TableRow>
							<TableRow>
								{columns.map((column) => (
									<TableCell
										key={column.field}
										align={column.align}
										style={{ minWidth: column.width }}
									>
										{column.headerName}
									</TableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{
								rows && rows.vehicles && rows.vehicles.length > 0 ?
									rows.vehicles
										.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
										.map((row, index) => {
											// if(row.removed) return;
											return (
												<TableRow hover role="checkbox" tabIndex={-1} key={row._id}>
													{columns.map((column) => {
														if (column.field === 'enabled') {
															return (
																<TableCell key={column.field} align={column.align}>
																	<EnableButton row={rows} index={index} />
																</TableCell>
															)
														}
														if (column.field === 'registration') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{withTooltip(`${row.vehicle.registration_number} - ${row.vehicle.registration_state}`, column.width)}
																</TableCell>
															)
														}
														if (column.field === 'last_updated') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{withTooltip(`${row.vehicle.tracker?.status[0] ? dayjs(row.vehicle.tracker.status[0].position_timestamp).format('DD-MM-YY HH:mm:ss') : 'Unavailable'}`, column.width)}
																</TableCell>
															)
														}
														if (column.field === 'current_temp') {
															return (
																<TableCell key={column.field} align={column.align}>
																	{withTooltip(`${row.vehicle.tracker?.status[0] ? row.vehicle.tracker.status[0].io.temperature : 'Unavailable'}`, column.width)}
																</TableCell>
															)
														}
														if (column.field === 'current_status') {
															return (
																<TableCell key={column.field} align={column.align}>
																	<Tooltip title="Temperature status">
																		{row.vehicle.tracker?.status[0] ? (row.vehicle.tracker.status[0].io.temperature < selectedAlert.condition.value || row.vehicle.tracker.status[0].io.temperature > selectedAlert.condition.value2) ?
																			<Chip color="secondary" label='Bad' /> :
																			<Chip color="primary" label='Good' /> :
																			<Chip label='Unavailable' />
																		}

																	</Tooltip>
																</TableCell>
															)
														}
														if (column.field === 'actions') {
															return (
																<TableCell align={column.align}>
																	<ActionButton row={rows} index={index} />
																</TableCell>
															)
														}
														const value = row.vehicle[column.field];
														return (
															<TableCell key={column.field} align={column.align}>
																{column.format && typeof value === "number"
																	? column.format(value)
																	: withTooltip(value, column.width)}
															</TableCell>
														);
													})}
												</TableRow>
											);
										})
									: <TableRow>
										<TableCell colSpan={columns.length} align={'center'}>
											No Vehicles Assigned
										</TableCell>
									</TableRow>
							}
						</TableBody>
					</Table>
				</TableContainer>
				<TablePagination
					rowsPerPageOptions={[10, 25, 100]}
					component="div"
					count={rows ? rows.vehicles.length : 0}
					rowsPerPage={rowsPerPage}
					page={page}
					onChangePage={handleChangePage}
					onChangeRowsPerPage={handleChangeRowsPerPage}
				/>
				{/* </Paper> */}
			</div>
		</Card>
	);
};


export default Results;
